// Imports
// React
import React from 'react';
import { LandingLayout } from '../modules/landing/components/LandingLayout';
import { ValidationHero } from '../modules/landing/components/ValidationHero';
import { useEmailCapture } from '../modules/landing/hooks/useEmailCapture';

// Component Definition
const LandingPage: React.FC = () => {
  const { submitEmail, isLoading, error, isSuccess } = useEmailCapture();

  // Wrapper function to match ValidationHero's expected signature
  const handleEmailSubmit = async (email: string): Promise<void> => {
    await submitEmail(email);
  };

  // Main Render
  return (
    <LandingLayout>
      <ValidationHero
        onEmailSubmit={handleEmailSubmit}
        isSubmitting={isLoading}
        submitError={error}
        showThankYou={isSuccess}
      />
    </LandingLayout>
  );
};

// Export
export default LandingPage;
